import {process24Hour,addZero,dateToTimeObj,condensedTimeRange} from '../../util/datetime'
import useCurrentUser from '../../hooks/useCurrentUser'
import Badge from 'react-bootstrap/Badge'
import moment from 'moment'


const Event = ({event,is24HourTime}) => {

	const {start,end,title,clients} = event

	const user = useCurrentUser()

	const clientNames = (
        clients?.length > 0 ?
        ` ${clients?.map( c => c?.user_name ).join(', ')}` :
        ''
    )

	const fontSize = 12

	const isGroupSession = event.event_type === 'group_session' || event.event_type === 'semi_private'
	const isParticipant = event.client_ids?.includes(user.user_id_number)
	const numParticipants = event.client_ids?.split(',').filter(Boolean).length

	const groupSessionSize = event.group_session_size

	return (
		<div style={{
			height:'100%',
			overflow:'hidden'
		}}>
			{(isGroupSession&&isParticipant)&&
				<i
					className="fas fa-user-check text-white mr-1 mb-1"
					style={{fontSize:'14px'}}
				/>
			}
			<small style={{fontWeight:'bold',fontSize}}>{title}</small>
			<small style={{fontSize}} className="ml-1">
				{
					is24HourTime
					? `${moment(start).format("HH:mm")} - ${moment(end).format("HH:mm")}`
					: condensedTimeRange(start,end)
				}
			</small>
			{(isGroupSession&&!isParticipant&&!isNaN(numParticipants)&&groupSessionSize)&&
				<small className="d-block mt-1">
					{groupSessionSize - numParticipants} spots left
				</small>
			}
			<small style={{fontSize}}>
				{clientNames}
			</small>
		</div>
	)
}

export default Event